import { render, staticRenderFns } from "./DialogFamiliar.vue?vue&type=template&id=dd7c3640"
import script from "./DialogFamiliar.vue?vue&type=script&lang=js"
export * from "./DialogFamiliar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports